module.exports = __webpack_public_path__ + "img/261-kiribati.81fec63e.svg";